import { Outlet, useNavigate } from 'react-router-dom'
import { useLoginContext } from '../../Contexts/LoginContext';
import { useEffect } from 'react';
import { useStoreHook } from '../../Hooks/StoreHook';

export default function Profile() {

    const { isAuthenticated } = useLoginContext();
    const { getLinkToHome } = useStoreHook();

    const navigate = useNavigate();

    useEffect(() => {
        if (!isAuthenticated) {
            navigate(getLinkToHome());
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!isAuthenticated) return null;
    
    return (
        <main>
            <Outlet />
        </main>
    )
};